require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-dean-wenick.json") })
        }
      }, "path---blog-author-dean-wenick");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-dean-wenick!./.cache/json/blog-author-dean-wenick.json
// module id = 624
// module chunks = 231608221292675